var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSolana(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2546 0H10.2705C15.6429 0 19.9997 4.35683 19.9997 9.72919V10.2708C19.9997 15.6432 15.6429 20 10.2705 20H10.2546C4.88222 20 0.525391 15.6432 0.525391 10.2708V9.72919C0.525391 4.35683 4.88222 0 10.2546 0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4242 7.52676C14.3923 7.5626 14.3525 7.59048 14.3087 7.60641C14.2649 7.62632 14.2171 7.63428 14.1693 7.63428H5.14897C4.83037 7.63428 4.66709 7.23604 4.89011 6.99709L6.37159 5.42401C6.40345 5.38817 6.44327 5.36029 6.49106 5.34038C6.53487 5.32047 6.58266 5.3125 6.63045 5.3125H15.6866C16.0092 5.3125 16.1685 5.71473 15.9415 5.95368L14.4242 7.52676ZM14.4242 14.5598C14.3565 14.6275 14.2649 14.6673 14.1693 14.6673H5.14897C4.83037 14.6673 4.66709 14.2771 4.89011 14.0461L6.37159 12.5088C6.40345 12.473 6.44725 12.4451 6.49106 12.4292C6.53487 12.4093 6.58266 12.4013 6.63045 12.4013H15.6866C16.0092 12.4013 16.1685 12.7956 15.9415 13.0266L14.4242 14.5598ZM14.4242 8.96443C14.3565 8.89673 14.2649 8.8569 14.1693 8.8569H5.14897C4.83037 8.8569 4.66709 9.24719 4.89011 9.47817L6.37159 11.0154C6.40345 11.0512 6.44725 11.0791 6.49106 11.0951C6.53487 11.115 6.58266 11.1229 6.63045 11.1229H15.6866C16.0092 11.1229 16.1685 10.7287 15.9415 10.4977L14.4242 8.96443Z",
    fill: "#333235"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolana);
export default __webpack_public_path__ + "static/media/solana.6edb9881d3dc9acb0990b399cae87a1b.svg";
export { ForwardRef as ReactComponent };